// src/tokens/font.ts
var fontFamilyRoboto = "Roboto";
export { fontFamilyRoboto };